var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1821_8865)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5.95728,
    r: 5,
    fill: "#64DD17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57532 5.7215L3.37915 6.98946L3.37915 4.45354L5.57532 5.7215Z",
    fill: "#64DD17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35456 2.95728L3.91819 6.39364L2.64547 5.12091L1.36365 6.40273L3.91819 8.95728L8.63637 4.23909L7.35456 2.95728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5.95728,
    r: 5,
    fill: "#64DD17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57532 5.7215L3.37915 6.98946L3.37915 4.45354L5.57532 5.7215Z",
    fill: "#64DD17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59999 7.51728L1.91999 5.83728L1.35999 6.39728L3.59999 8.63728L8.39999 3.83728L7.83999 3.27728L3.59999 7.51728Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1821_8865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.957275)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/delivered.31914f6c6ba6ea116b00c883cfc76b33.svg";
export { ForwardRef as ReactComponent };